<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    <div class="title" v-if="orderDetail.sync_type=='1'">仓储取货详情</div>
    <div class="title" v-if="orderDetail.sync_type=='2'">仓储送回详情</div>
    <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">订单号：WP{{orderDetail.sync_id}} </h2>
        <h2 class="weui-msg__title">{{order_status()}}</h2>

    </div>

    <div class="weui-cells__title" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">费用详情</div>

    <div class="weui-cells" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">
      <a class="weui-cell" href="javascript:;" >
          <div class="weui-cell__bd">
              <p>总费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.order_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='1'">
          <div class="weui-cell__bd">
              <p>定金</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.deposit_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='1'">
          <div class="weui-cell__bd">
              <p>服务尾款</p>
          </div>
          <div class="weui-cell__ft">{{(orderDetail.order_amount - orderDetail.deposit_amount) | numeral('$0,0.00')}}</div>
      </a>
    </div>


    <div class="weui-cells__title">基本信息</div>
    <div class="weui-cells">
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='1'">
          <div class="weui-cell__bd" >
              <p>联系人</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.out_address.out_name}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='1'">
          <div class="weui-cell__bd">
              <p>联系手机</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.out_address.out_phone}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='1'" >
          <div class="weui-cell__bd">
              <p>取货时间</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.service_date | moment("YYYY年M月D日")}} {{orderDetail.service_time}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='1'">
          <div class="weui-cell__bd">
              <p>取货地址</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.out_address.out_street}}, {{orderDetail.details.out_address.out_suburb}}, {{orderDetail.details.out_address.out_state}}, {{orderDetail.details.out_address.out_postcode}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='2'">
          <div class="weui-cell__bd" >
              <p>联系人</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_name}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='2'">
          <div class="weui-cell__bd">
              <p>联系手机</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_phone}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='2'">
          <div class="weui-cell__bd">
              <p>送回地址</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_street}}, {{orderDetail.details.in_address.in_suburb}}, {{orderDetail.details.in_address.in_state}}, {{orderDetail.details.in_address.in_postcode}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='2'">
          <div class="weui-cell__bd">
              <p>送回时间</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.service_date | moment("YYYY年M月D日")}} {{orderDetail.service_time}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.sync_type=='2'">
          <div class="weui-cell__bd">
              <p>送回地址</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.in_address.in_street}}, {{orderDetail.details.in_address.in_suburb}}, {{orderDetail.details.in_address.in_state}}, {{orderDetail.details.in_address.in_postcode}}</div>
      </a>
    </div>
    <div class="weui-cells__title">价格细节</div>

    <div class="weui-cells"  v-if="orderDetail.sync_type=='1'">
      <a class="weui-cell" href="javascript:;" >
          <div class="weui-cell__bd">
              <p>套餐价格</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.plan_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.stairs_cost>0">
          <div class="weui-cell__bd">
              <p>楼梯费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;"  v-if="orderDetail.details.wait_cost>0">
          <div class="weui-cell__bd">
              <p>超时等待费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.wait_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.other_amount>0">
          <div class="weui-cell__bd">
              <p>其他费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.offers_amount>0">
          <div class="weui-cell__bd">
              <p>优惠金额</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
      </a>
    </div>

    <div class="weui-cells"  v-if="orderDetail.sync_type=='2'">
      <a class="weui-cell" href="javascript:;"  v-if="orderDetail.details.overdue_cost>0">
          <div class="weui-cell__bd">
              <p>逾期费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.overdue_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.details.stairs_cost>0">
          <div class="weui-cell__bd">
              <p>楼梯费</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" >
          <div class="weui-cell__bd">
              <p>其他费用</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
      </a>
      <a class="weui-cell" href="javascript:;" v-if="orderDetail.offers_amount>0">
          <div class="weui-cell__bd">
              <p>优惠金额</p>
          </div>
          <div class="weui-cell__ft">{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
      </a>
    </div>
    <div class="btn-box-fix" v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
      <div class="btn-container">
        <div class="btn active" @click="checkSubmit()">立即支付</div>
      </div>
    </div>

  </div>

</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      orderDetail:{
        "order_id": "",
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "gst_amount": "",
        "cancelfee_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": "",
        "other_amount_data": "",
        "invoices_url": "",
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
            "operates_num": 0
        },
        "details": {
            "student_plan": "",
            "baggage": "",
            "in_address": {
                "pick_street": "",
                "pick_suburb": "",
                "pick_state": "",
                "pick_postcode": ""
            },
            "pick_date": "",
            "pick_time": "",
            "pick_period": "",
            "return_address": {
                "return_street": "",
                "return_suburb": "",
                "return_state": "",
                "return_postcode": ""
            },
            "return_date": "",
            "return_time": "",
            "return_period": "",
            "contact_bak": "",
            "return_pending": "",
            "student_plan_name": ""
        },
        "expiration_time": 0,
        "lifecycle_text": "",
        "lifecycle_status": 0
      }
    }
  },
  methods: {
    order_status: function () {
      let result = '';
      switch (this.orderDetail.pay_status) {
        case "0":
          result = '订单已确认，待支付定金 $'+this.orderDetail.deposit_amount;
          break;
        case "1":
          result = '已付定金，等待服务'
          break;
        case "2":
          result = '服务完毕，待支付全款'
          break;
        case "3":
          result = '已付款，等待确认到账'
          break;
        case "4":
          result = '已付款完毕，感谢使用我们的服务'
          break;
        case "5":
          result = '已退款'
          break;
        default:
          console.log("订单状态异常");
      }
      return result;
    },

    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/getDeposit', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            console.log(that.orderDetail)
            if(that.orderDetail.lifecycle_status==1){
              that.$router.push('/order-cancel?reason=timeout');
            }
            if(that.orderDetail.order_status==8){
              that.$router.push('/order-cancel');
            }
            if(that.orderDetail.pay_status==0||that.orderDetail.pay_status==1){
              
            }
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    checkSubmit(){
      if(this.orderDetail.pay_status==0){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&subtype=wp&status=0&amount='+this.depositAmount());
      }
      if(this.orderDetail.pay_status==2){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&subtype=wp&status=2&amount='+this.orderDetail.payment_amount);
      }
    },
    goback(){
      this.$router.push('/storage/order-detail?id='+ this.orderDetail.sync_order_number);
    },
  },
  components: {
  },
  computed: {
    orderIDFromURL: function (){
      let theString = this.$route.query.id;
      if(theString.includes("?")){
        return theString.substring(0, theString.indexOf('?'));
      }
      else{
        return theString;
      }
    },
    updateLink: function (){
      return "/storage/order-update?id="+this.$route.query.id;
    },
    pick_period: function () {
      let result = '';
      switch (this.orderDetail.details.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.orderDetail.details.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    pricingURL: function (){
      let theString = this.$route.query.id;
      return '/storage/order-detail/price?id=' + theString;
    },
    pricing: function () {
      let result = '';
      switch (this.orderDetail.details.student_plan) {
        case "1668743923":
          result = '298'
          break;
        case "1668743953":
          result = '428'
          break;
        case "1668743985":
          result = '568'
          break;
        case "1668744048":
          result = '688'
          break;
        default:
          console.log("1");
      }
      return result;
    },

  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/storage/order-detail-sub.vue